var isTagged = function isTagged(tag) {
  return function (u) {
    return !!u && u._tag === tag;
  };
};

export { isTagged as i };
